import { appAxiosInstance } from "./getAxiosInstance.ts";

export interface AppRole {
    roleId: number
    roleName: string
}

export interface AppPermission {
    id: number
    displayName: string
    moduleName: string
}

export interface EffectivePermissionsResult {
    permissions: AppPermission[]
    roles: AppRole[]
}
export interface UserData {
    resourceId: number
    name: string
    email?: string,
    emailId?: string,
    status: string,
    grade: string,
    permissions?: EffectivePermissionsResult,
}
export interface AppUserAccount {
    data: UserData
    resourceId: number
    name: string
    email?: string,
    emailId?: string,
    permissions?: EffectivePermissionsResult
}

export async function getAccount() {
    const { data } = await appAxiosInstance
        .get<AppUserAccount>('/api/alumni/Accounts');

    return data;
}